import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

const page = () => import("./MediaLibraryPage");

export const medialibModule = defineModule({
  name: "medialib",
  label: "Media library",
  requires: ["core", "accounts"],
  i18n: { en },
  admin: {
    routes: [{ path: "media", permission: "medialib.view_mediafile", page }],
    nav: [
      {
        id: "media",
        group: "content",
        label: "medialib:nav",
        icon: "image",
        to: "/media",
        permission: "medialib.view_mediafile",
        order: 5,
      },
    ],
  },
  // The store's own library: the same page, scoped to the store by the API (team-role code `media.manage`).
  vendor: {
    routes: [{ path: "media", permission: "media.manage", page }],
    nav: [
      {
        id: "media",
        group: "catalog",
        label: "medialib:nav",
        icon: "image",
        to: "/media",
        permission: "media.manage",
        order: 50,
      },
    ],
  },
});
